
class CustomShopTheLook extends HTMLElement {
    constructor() {
        super();
        this.checkInputs = this.checkInputs.bind(this);
        this.submitForms = this.submitForms.bind(this);
    }

    connectedCallback() {
        this.dom = {
            forms: this.querySelectorAll('form'),
            selects: this.querySelectorAll('form select'),
            footer: this.querySelector('.custom-shop-the-look__footer'),
            submitButton: this.querySelector('button[data-submit-button]'),
            modal: this.closest('gtc-modal')
        };
        this.addEventListeners();
    }

    addEventListeners() {
        this.addEventListener('shop-the-look-form-change', this.checkInputs);
        this.dom.submitButton.addEventListener('click', this.submitForms);
    }

    checkInputs() {
        const hasValidSelectedValue = Array.from(this.dom.selects).some(select => select.value !== '' && !select.selectedOptions[0].disabled);
        this.dom.submitButton.disabled = !hasValidSelectedValue;
    }

    async submitForms() {

        // Get the form data from all forms, and merge them into a single object but keep unique values
        const productData = {
            items: Array.from(this.dom.selects).map(select => {
                const variantId = select.value;
                const quantity = 1;

                if (!variantId || variantId === '' || variantId === 'null' || select.selectedOptions[0].disabled) {
                    return;
                }

                return {
                    id: variantId,
                    quantity
                };
            })
        };


        const config = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'X-Requested-With': 'XMLHttpRequest'
            },
            body: JSON.stringify(productData)
        };

        try {
            const response = await fetch('/cart/add.js', config);
            const responseJson = await response.json();

            if (!response.ok) {
                this.writeError(responseJson);
                throw new Error(responseJson.message);
            }


            const dispatchCartRefreshEvent = () => {
                document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
            };

            const getCartDrawer = () => document.querySelector('cart-drawer');

            dispatchCartRefreshEvent();
            const themeCartDrawer = getCartDrawer();
            if (themeCartDrawer) themeCartDrawer.show();

        } catch (error) {
            console.error('Error:', error);
        }

        if (this.dom.modal && response.ok) this.dom.modal.close();
    }

    writeError(error) {
        const errorText = error.message ? error.message : 'Something went wrong';

        if (this.dom.footer) {

            const errorElement = document.createElement('div');
            errorElement.textContent = errorText;
            errorElement.classList.add('gtc-bonus-item-error');
            this.dom.footer.prepend(errorElement);
            setTimeout(() => errorElement.remove(), 5000);
        } else {
            alert(errorText);
        }
    }
}

if (!customElements.get('shop-the-look')) {
    customElements.define('shop-the-look', CustomShopTheLook);
}


class CustomShopTheLookForm extends HTMLElement {
    constructor() {
        super();
        this.formChange = this.formChange.bind(this);
        this.checkboxChange = this.checkboxChange.bind(this);
    }

    connectedCallback() {
        this.dom = {
            form: this.querySelector('form'),
            select: this.querySelector('select'),
            checkboxs: this.querySelectorAll('input[type="checkbox"]'),
        };
        this.addEventListeners();
    }

    addEventListeners() {
        this.dom.form.addEventListener('change', this.formChange);
        this.dom.checkboxs.forEach(checkbox => {
            checkbox.addEventListener('change', this.checkboxChange);
        });
    }

    checkboxChange(event) {
        if (!event.target.checked) return;
        const otherCheckboxes = Array.from(this.dom.checkboxs).filter(checkbox => checkbox !== event.target);
        otherCheckboxes.forEach(checkbox => {
            checkbox.checked = false;
        });
    }

    formChange(event) {
        this.dom.select.value = event.target.checked ? event.target.value : '';
        this.dispatchEvent(new CustomEvent('shop-the-look-form-change', {
            bubbles: true,
            detail: {
                form: this.dom.form,
                select: this.dom.select,
            }
        }));
    }
}

if (!customElements.get('custom-shop-the-look-form')) {
    customElements.define('custom-shop-the-look-form', CustomShopTheLookForm);
}